import {
  BrowserMessageReceiveType,
  registerElectronMessageReceiver,
} from 'electron-communication-lib/BrowserForApp';
import {useRef} from 'react';
import {useMountEffect} from 'webapp-lib/utils';

import {useRouteNavigate} from '_/hooks/useRouteNavigate';

export function useOpenFileCommand(): void {
  const {goToCasusDocuments} = useRouteNavigate();
  // Application creates a new router on every render; a navigate
  // captured at mount would keep addressing the first one.
  const goToCasusDocumentsRef = useRef(goToCasusDocuments);
  goToCasusDocumentsRef.current = goToCasusDocuments;

  useMountEffect(() => {
    registerElectronMessageReceiver(
      BrowserMessageReceiveType.EXTERNAL_DOCUMENT_OPEN,
      (openDocumentUrlParams) =>
        goToCasusDocumentsRef.current({
          casusId: openDocumentUrlParams.casusId,
          folderId: openDocumentUrlParams.folderId,
          documentId: openDocumentUrlParams.documentId,
          action: 'open-document',
        })
    );
  });
}
